// extracted by mini-css-extract-plugin
module.exports =  {"vertical":"_0bc5e8de02--vertical--f5kn6","button-container":"_0bc5e8de02--button-container--DaUmy","horizontal":"_0bc5e8de02--horizontal--Tsjvv"};